import React from "react";
import PropTypes from "prop-types";

// Material
import { makeStyles } from "@material-ui/core/styles";
import Paper from "@material-ui/core/Paper";

// Config
import { getRoute, urls } from "../../config/routes";
import styles from "../../config/styles";
import useTranslate from "../../hooks/useTranslate";

// Components
import CardHeader from "../CardHeader";
import CaseSteps from "./CaseSteps";

const useStyles = makeStyles(theme => ({
  root: {
    border: styles.values.border,
    overflow: "hidden",
    marginBottom: theme.spacing(1)
  }
}));

const CaseDetail = ({ data, isNew, showSteps, isNewIntel }) => {
  const classes = useStyles();
  const getText = useTranslate();

  const newCaseTitle = getText("createCasePage.newCase");

  if (!data) return null;

  return (
    <Paper elevation={0} className={classes.root}>
      <CardHeader
        isButton
        isIntel={data.isIntel || isNewIntel}
        to={getRoute(urls.caseDetail, { caseId: data.id })}
        title={isNew ? newCaseTitle : data.number}
        victimName={data.patientName}
      />
      {!isNew && showSteps && <CaseSteps />}
    </Paper>
  );
};

CaseDetail.propTypes = {
  data: PropTypes.shape({
    id: PropTypes.string,
    injuries: PropTypes.arrayOf(PropTypes.shape({})),
    isDraft: PropTypes.bool,
    number: PropTypes.string,
    patientName: PropTypes.string,
    isIntel: PropTypes.bool
  }),
  isNew: PropTypes.bool,
  showSteps: PropTypes.bool,
  isNewIntel: PropTypes.bool.isRequired
};

CaseDetail.defaultProps = {
  data: {},
  isNew: false,
  showSteps: false
};

export default CaseDetail;
